import React from "react";
import { COMPANYID, MODAL_SIZE } from "../../App.config";
import Backbutton from "../../containers/Common/Backbutton";
import LevelPng from "../../images/level.png";
import UserSvg from "../../images/user-orange.svg";
import D1 from "../../Docs/ABCDeptMapFile.xlsx";
import D2 from "../../Docs/ABCEmpData.xlsx";
import * as utilities from "../../utilities/utils";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionMenuItem";
import FileUploadHistoryComponent from "../../containers/FileUploadHistory";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { useEffect } from "react";
import swal from "sweetalert";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

const FileUploadsComponent = (props) => {

    const handleOnFileChange = (event) => {
        if (!event.target.files.length)
            return;
        let Vfiles = event.target.files
        let filename = Vfiles[0].name
        let result = filename.match("^.+\.(xlsx)$")
        if (result == null) {
            alert("Please upload an XLSX file only (Excel File)");
        }
        else {
            let { files } = event.target;
            let formData = new FormData();
            if (files[0]) {
                formData.append("file", files[0]);
                formData.append("companyId", props.profileReducer && props.profileReducer.managersDetails && props.profileReducer.managersDetails.companyId);
                formData.append("authToken", utilities.getTokenHeader().authToken);
                props.saveTreeView(formData);
            }
        }

        event.target.value = ''
    }

    const handleOnEmployeeImport = (event) => {
        if (!event.target.files.length)
            return;
        let Vfiles = event.target.files
        let filename = Vfiles[0].name
        let result = filename.match("^.+\.(xlsx)$")
        if (result == null) {
            alert("Please upload an XLSX file only (Excel File)");
        }
        else {
            let { files } = event.target;
            let formData = new FormData();
            if (files[0]) {
                formData.append("file", files[0]);
                formData.append("companyId", props.profileReducer && props.profileReducer.managersDetails && props.profileReducer.managersDetails.companyId);
                formData.append("authToken", utilities.getTokenHeader().authToken);
                props.saveEmployeeData(formData);
            }
        }

        event.target.value = ''
    }

    useEffect(() => {
        if (props.fileHistory && props.fileHistory.length > 0) {
            props.openSetModalAction(<FileUploadHistoryComponent closeRemoveModal={props.closeRemoveModal} history={props.fileHistory} context={props.context} />, MODAL_SIZE.MODAL_MD);
        }
    }, [props.fileHistory])

    const openFileUploadHistoryComponent = (fileLevel) => {

        // props.getFileUploadHistory(fileLevel);
    }

    return (
        <div className="Dashboard-service">
            <div className="row">
                <div className="back-btn-outer">

                    <Backbutton />
                </div>
            </div>
            <div className="service-box">
                <DisplayEmployeeName context={props.context} />
                <div className="row">
                    {props.profileReducer && props.profileReducer.companyServices ?
                        !props.profileReducer.companyServices.hasLevelFileFeature
                            && !props.profileReducer.companyServices.hasDemographicFileFeature ?
                            <>
                                <h4><i className="text-danger text-center"></i>{props.context.t("DASHBOARD-Hello.Service.Not.Found")}</h4>
                            </> : props.profileReducer.companyServices.hasLevelFileFeature && !props.profileReducer.companyServices.hasDemographicFileFeature ?
                                <>
                                    <h4><i className="text-danger text-center"></i>{props.context.t("FILE_UPLOAD.Demographic.Feature.Not.Available")}</h4>
                                </> : !props.profileReducer.companyServices.hasLevelFileFeature && props.profileReducer.companyServices.hasDemographicFileFeature ?
                                    <>
                                        <h4><i className="text-danger text-center"></i>{props.context.t("FILE_UPLOAD.Level.Feature.Not.Available")}</h4>
                                    </>
                                    : null
                        : null}
                </div>
                <div className="row">
                    <ShowForPermission module={PERMISSON_MODULES.LEVEL_DATA_FILE_UPLOADS}
                        permission={PERMISSION_TYPE.VIEW}>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                            <div className="s-box">
                                <div className="srv-img">
                                    <img src={LevelPng} alt="" />
                                    <i className="fa fa-home"></i>
                                </div>
                                <h2>{props.context.t("FILE_UPLOAD.Level.Data.Import")}</h2>
                                <a href={D1} download={D1.xlsx}>{props.context.t("FILE_UPLOAD.Download.Sample.File")}</a>
                                <span className="mr-2">
                                    <input name="dept" type="file" id="upload" hidden onChange={(e) => { handleOnFileChange(e) }} />
                                    <label for="upload" className="file-upload mt-0">{props.context.t("FILE_UPLOAD.Organizational.Hierarchy.Import")}</label>
                                </span>
                                <span className="mr-2">
                                    <button className="file-upload mt-0 btn btn-primary" onClick={() => props.getFileHistory(1)}>{props.context.t("FILE_UPLOAD.File.History")}</button>
                                </span>
                            </div>
                        </div>
                    </ShowForPermission>
                    <ShowForPermission module={PERMISSON_MODULES.EMPLOYEE_FILE_UPLOADS}
                        permission={PERMISSION_TYPE.VIEW}>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                            <div className="s-box">
                                <div className="srv-img">
                                    <img src={UserSvg} alt="" />
                                </div>
                                <h2>{props.context.t("FILE_UPLOAD.Employees.Import")}</h2>
                                <a href={D2} download={D2.xlsx}>{props.context.t("FILE_UPLOAD.Download.Sample.File")}</a>

                                <span>
                                    <input name="emp" type="file" id="uploadEmployee" hidden onChange={(e) => { handleOnEmployeeImport(e) }} />
                                    <label for="uploadEmployee" className="file-upload mt-0">{props.context.t("FILE_UPLOAD.Employee.Demographic.Import")}</label>
                                </span>
                                <span className="mr-2">
                                    <button className="file-upload mt-0 btn btn-primary" onClick={() => props.getFileHistory(2)}>{props.context.t("FILE_UPLOAD.File.History")}</button>
                                </span>
                            </div>
                        </div>
                    </ShowForPermission>
                </div>
            </div>
        </div>
    );
};
export default FileUploadsComponent;
